import * as React from 'react'
import Switch from '@mui/material/Switch'
import Typography from '@mui/material/Typography'

import { toggleTidalThemeActive, useTidalThemeActive } from './store'
import { isProduction } from '@sales-center/common'
import { useTheme } from '@mui/material/styles'

type TidalThemeSwitchProps = {
  contrastText?: boolean
}

export function TidalThemeSwitchDev(props: TidalThemeSwitchProps) {
  const checked = useTidalThemeActive()
  const { contrastText } = props
  const theme = useTheme()
  return (
    <Typography
      display={isProduction ? 'none' : 'block'}
      marginLeft={2}
      variant="caption"
      fontWeight="600"
      color={
        contrastText
          ? theme.palette.primary.contrastText
          : theme.palette.text.primary
      }
      data-test-id="tidal-theme-toggle"
    >
      <Switch checked={checked} onChange={toggleTidalThemeActive} />
      Tidal On/Off
    </Typography>
  )
}
